import { createMachine } from 'xstate';

export const InvokerMachine = createMachine({
  id: 'invoker',
  initial: 'idle',
  states: {
    idle: {
      on: {
        INVOKE: 'loading',
      },
    },
    loading: {
      on: {
        SUCCESS: 'success',
        FAILURE: 'failure',
      },
    },
    success: {
      type: 'final',
    },
    failure: {
      on: {
        INVOKE: 'loading',
      },
    },
  },
});
